/* VERSION: 1.0.0 Please do not delete this line. Thank you! */
/* eslint-disable */
// prettier-ignore

if (
  (typeof lazySizes !== 'function' && typeof lazySizes !== 'object') ||
  typeof lazySizes === 'undefined'
) {
  /*! lazysizes - v4.1.8 */
  !(function (a, b) {
    const c = b(a, a.document);
    (a.lazySizes = c), typeof module === 'object' && module.exports && (module.exports = c);
  })(window, function (a, b) {
    if (b.getElementsByClassName) {
      let c;
      let d;
      const e = b.documentElement;
      const f = a.Date;
      const g = a.HTMLPictureElement;
      const h = 'addEventListener';
      const i = 'getAttribute';
      const j = a[h];
      const k = a.setTimeout;
      const l = a.requestAnimationFrame || k;
      const m = a.requestIdleCallback;
      const n = /^picture$/i;
      const o = ['load', 'error', 'lazyincluded', '_lazyloaded'];
      const p = {};
      const q = Array.prototype.forEach;
      const r = function (a, b) {
        return (
          p[b] || (p[b] = new RegExp(`(\\s|^)${b}(\\s|$)`)), p[b].test(a[i]('class') || '') && p[b]
        );
      };
      const s = function (a, b) {
        r(a, b) || a.setAttribute('class', `${(a[i]('class') || '').trim()} ${b}`);
      };
      const t = function (a, b) {
        let c;
        (c = r(a, b)) && a.setAttribute('class', (a[i]('class') || '').replace(c, ' '));
      };
      var u = function (a, b, c) {
        const d = c ? h : 'removeEventListener';
        c && u(a, b),
          o.forEach(function (c) {
            a[d](c, b);
          });
      };
      const v = function (a, d, e, f, g) {
        const h = b.createEvent('Event');
        return (
          e || (e = {}),
          (e.instance = c),
          h.initEvent(d, !f, !g),
          (h.detail = e),
          a.dispatchEvent(h),
          h
        );
      };
      const w = function (b, c) {
        let e;
        !g && (e = a.picturefill || d.pf)
          ? (c && c.src && !b[i]('srcset') && b.setAttribute('srcset', c.src),
            e({ reevaluate: !0, elements: [b] }))
          : c && c.src && (b.src = c.src);
      };
      const x = function (a, b) {
        return (getComputedStyle(a, null) || {})[b];
      };
      const y = function (a, b, c) {
        for (c = c || a.offsetWidth; c < d.minSize && b && !a._lazysizesWidth; )
          (c = b.offsetWidth), (b = b.parentNode);
        return c;
      };
      const z = (function () {
        let a;
        let c;
        const d = [];
        const e = [];
        let f = d;
        const g = function () {
          const b = f;
          for (f = d.length ? e : d, a = !0, c = !1; b.length; ) b.shift()();
          a = !1;
        };
        const h = function (d, e) {
          a && !e ? d.apply(this, arguments) : (f.push(d), c || ((c = !0), (b.hidden ? k : l)(g)));
        };
        return (h._lsFlush = g), h;
      })();
      const A = function (a, b) {
        return b
          ? function () {
              z(a);
            }
          : function () {
              const b = this;
              const c = arguments;
              z(function () {
                a.apply(b, c);
              });
            };
      };
      const B = function (a) {
        let b;
        let c = 0;
        const e = d.throttleDelay;
        let g = d.ricTimeout;
        const h = function () {
          (b = !1), (c = f.now()), a();
        };
        const i =
          m && g > 49
            ? function () {
                m(h, { timeout: g }), g !== d.ricTimeout && (g = d.ricTimeout);
              }
            : A(function () {
                k(h);
              }, !0);
        return function (a) {
          let d;
          (a = !0 === a) && (g = 33),
            b || ((b = !0), (d = e - (f.now() - c)), d < 0 && (d = 0), a || d < 9 ? i() : k(i, d));
        };
      };
      const C = function (a) {
        let b;
        let c;
        const d = 99;
        const e = function () {
          (b = null), a();
        };
        var g = function () {
          const a = f.now() - c;
          a < d ? k(g, d - a) : (m || e)(e);
        };
        return function () {
          (c = f.now()), b || (b = k(g, d));
        };
      };
      !(function () {
        let b;
        const c = {
          lazyClass: 'lazyload',
          loadedClass: 'lazyloaded',
          loadingClass: 'lazyloading',
          preloadClass: 'lazypreload',
          errorClass: 'lazyerror',
          autosizesClass: 'lazyautosizes',
          srcAttr: 'data-src',
          srcsetAttr: 'data-srcset',
          sizesAttr: 'data-sizes',
          minSize: 40,
          customMedia: {},
          init: !0,
          expFactor: 1.5,
          hFac: 0.8,
          loadMode: 2,
          loadHidden: !0,
          ricTimeout: 0,
          throttleDelay: 125,
        };
        d = a.lazySizesConfig || a.lazysizesConfig || {};
        for (b in c) b in d || (d[b] = c[b]);
        (a.lazySizesConfig = d),
          k(function () {
            d.init && F();
          });
      })();
      const D = (function () {
        let g;
        let l;
        let m;
        let o;
        let p;
        let y;
        let D;
        let F;
        let G;
        let H;
        let I;
        let J;
        const K = /^img$/i;
        const L = /^iframe$/i;
        const M = 'onscroll' in a && !/(gle|ing)bot/.test(navigator.userAgent);
        const N = 0;
        let O = 0;
        let P = 0;
        let Q = -1;
        const R = function (a) {
          P--, (!a || P < 0 || !a.target) && (P = 0);
        };
        const S = function (a) {
          return (
            J == null && (J = x(b.body, 'visibility') == 'hidden'),
            J || (x(a.parentNode, 'visibility') != 'hidden' && x(a, 'visibility') != 'hidden')
          );
        };
        const T = function (a, c) {
          let d;
          let f = a;
          let g = S(a);
          for (F -= c, I += c, G -= c, H += c; g && (f = f.offsetParent) && f != b.body && f != e; )
            (g = (x(f, 'opacity') || 1) > 0) &&
              x(f, 'overflow') != 'visible' &&
              ((d = f.getBoundingClientRect()),
              (g = H > d.left && G < d.right && I > d.top - 1 && F < d.bottom + 1));
          return g;
        };
        const U = function () {
          let a;
          let f;
          let h;
          let j;
          let k;
          let m;
          let n;
          let p;
          let q;
          let r;
          let s;
          let t;
          const u = c.elements;
          if ((o = d.loadMode) && P < 8 && (a = u.length)) {
            for (f = 0, Q++; f < a; f++)
              if (u[f] && !u[f]._lazyRace)
                if (!M || (c.prematureUnveil && c.prematureUnveil(u[f]))) aa(u[f]);
                else if (
                  (((p = u[f][i]('data-expand')) && (m = 1 * p)) || (m = O),
                  r ||
                    ((r =
                      !d.expand || d.expand < 1
                        ? e.clientHeight > 500 && e.clientWidth > 500
                          ? 500
                          : 370
                        : d.expand),
                    (c._defEx = r),
                    (s = r * d.expFactor),
                    (t = d.hFac),
                    (J = null),
                    O < s && P < 1 && Q > 2 && o > 2 && !b.hidden
                      ? ((O = s), (Q = 0))
                      : (O = o > 1 && Q > 1 && P < 6 ? r : N)),
                  q !== m &&
                    ((y = innerWidth + m * t), (D = innerHeight + m), (n = -1 * m), (q = m)),
                  (h = u[f].getBoundingClientRect()),
                  (I = h.bottom) >= n &&
                    (F = h.top) <= D &&
                    (H = h.right) >= n * t &&
                    (G = h.left) <= y &&
                    (I || H || G || F) &&
                    (d.loadHidden || S(u[f])) &&
                    ((l && P < 3 && !p && (o < 3 || Q < 4)) || T(u[f], m)))
                ) {
                  if ((aa(u[f]), (k = !0), P > 9)) break;
                } else
                  !k &&
                    l &&
                    !j &&
                    P < 4 &&
                    Q < 4 &&
                    o > 2 &&
                    (g[0] || d.preloadAfterLoad) &&
                    (g[0] || (!p && (I || H || G || F || u[f][i](d.sizesAttr) != 'auto'))) &&
                    (j = g[0] || u[f]);
            j && !k && aa(j);
          }
        };
        const V = B(U);
        const W = function (a) {
          const b = a.target;
          if (b._lazyCache) return void delete b._lazyCache;
          R(a), s(b, d.loadedClass), t(b, d.loadingClass), u(b, Y), v(b, 'lazyloaded');
        };
        const X = A(W);
        var Y = function (a) {
          X({ target: a.target });
        };
        const Z = function (a, b) {
          try {
            a.contentWindow.location.replace(b);
          } catch (c) {
            a.src = b;
          }
        };
        const $ = function (a) {
          let b;
          const c = a[i](d.srcsetAttr);
          (b = d.customMedia[a[i]('data-media') || a[i]('media')]) && a.setAttribute('media', b),
            c && a.setAttribute('srcset', c);
        };
        const _ = A(function (a, b, c, e, f) {
          let g;
          let h;
          let j;
          let l;
          let o;
          let p;
          (o = v(a, 'lazybeforeunveil', b)).defaultPrevented ||
            (e && (c ? s(a, d.autosizesClass) : a.setAttribute('sizes', e)),
            (h = a[i](d.srcsetAttr)),
            (g = a[i](d.srcAttr)),
            f && ((j = a.parentNode), (l = j && n.test(j.nodeName || ''))),
            (p = b.firesLoad || ('src' in a && (h || g || l))),
            (o = { target: a }),
            s(a, d.loadingClass),
            p && (clearTimeout(m), (m = k(R, 2500)), u(a, Y, !0)),
            l && q.call(j.getElementsByTagName('source'), $),
            h
              ? a.setAttribute('srcset', h)
              : g && !l && (L.test(a.nodeName) ? Z(a, g) : (a.src = g)),
            f && (h || l) && w(a, { src: g })),
            a._lazyRace && delete a._lazyRace,
            t(a, d.lazyClass),
            z(function () {
              const b = a.complete && a.naturalWidth > 1;
              (p && !b) ||
                (b && s(a, 'ls-is-cached'),
                W(o),
                (a._lazyCache = !0),
                k(function () {
                  '_lazyCache' in a && delete a._lazyCache;
                }, 9)),
                a.loading == 'lazy' && P--;
            }, !0);
        });
        var aa = function (a) {
          if (!a._lazyRace) {
            let b;
            const c = K.test(a.nodeName);
            const e = c && (a[i](d.sizesAttr) || a[i]('sizes'));
            const f = e == 'auto';
            ((!f && l) ||
              !c ||
              (!a[i]('src') && !a.srcset) ||
              a.complete ||
              r(a, d.errorClass) ||
              !r(a, d.lazyClass)) &&
              ((b = v(a, 'lazyunveilread').detail),
              f && E.updateElem(a, !0, a.offsetWidth),
              (a._lazyRace = !0),
              P++,
              _(a, b, f, e, c));
          }
        };
        const ba = C(function () {
          (d.loadMode = 3), V();
        });
        const ca = function () {
          d.loadMode == 3 && (d.loadMode = 2), ba();
        };
        var da = function () {
          if (!l) {
            if (f.now() - p < 999) return void k(da, 999);
            (l = !0), (d.loadMode = 3), V(), j('scroll', ca, !0);
          }
        };
        return {
          _() {
            (p = f.now()),
              (c.elements = b.getElementsByClassName(d.lazyClass)),
              (g = b.getElementsByClassName(`${d.lazyClass} ${d.preloadClass}`)),
              j('scroll', V, !0),
              j('resize', V, !0),
              a.MutationObserver
                ? new MutationObserver(V).observe(e, { childList: !0, subtree: !0, attributes: !0 })
                : (e[h]('DOMNodeInserted', V, !0),
                  e[h]('DOMAttrModified', V, !0),
                  setInterval(V, 999)),
              j('hashchange', V, !0),
              [
                'focus',
                'mouseover',
                'click',
                'load',
                'transitionend',
                'animationend',
                'webkitAnimationEnd',
              ].forEach(function (a) {
                b[h](a, V, !0);
              }),
              /d$|^c/.test(b.readyState)
                ? da()
                : (j('load', da), b[h]('DOMContentLoaded', V), k(da, 2e4)),
              c.elements.length ? (U(), z._lsFlush()) : V();
          },
          checkElems: V,
          unveil: aa,
          _aLSL: ca,
        };
      })();
      var E = (function () {
        let a;
        const c = A(function (a, b, c, d) {
          let e;
          let f;
          let g;
          if (
            ((a._lazysizesWidth = d),
            (d += 'px'),
            a.setAttribute('sizes', d),
            n.test(b.nodeName || ''))
          )
            for (e = b.getElementsByTagName('source'), f = 0, g = e.length; f < g; f++)
              e[f].setAttribute('sizes', d);
          c.detail.dataAttr || w(a, c.detail);
        });
        const e = function (a, b, d) {
          let e;
          const f = a.parentNode;
          f &&
            ((d = y(a, f, d)),
            (e = v(a, 'lazybeforesizes', { width: d, dataAttr: !!b })),
            e.defaultPrevented ||
              ((d = e.detail.width) && d !== a._lazysizesWidth && c(a, f, e, d)));
        };
        const f = function () {
          let b;
          const c = a.length;
          if (c) for (b = 0; b < c; b++) e(a[b]);
        };
        const g = C(f);
        return {
          _() {
            (a = b.getElementsByClassName(d.autosizesClass)), j('resize', g);
          },
          checkElems: g,
          updateElem: e,
        };
      })();
      var F = function () {
        F.i || ((F.i = !0), E._(), D._());
      };
      return (c = {
        cfg: d,
        autoSizer: E,
        loader: D,
        init: F,
        uP: w,
        aC: s,
        rC: t,
        hC: r,
        fire: v,
        gW: y,
        rAF: z,
      });
    }
  });
  /*! ls.rias.min.ks - v4.1.8 */
  !(function (a, b) {
    var c = function () {
      b(a.lazySizes), a.removeEventListener('lazyunveilread', c, !0);
    };
    (b = b.bind(null, a, a.document)),
      typeof module === 'object' && module.exports
        ? b(require('lazysizes'))
        : a.lazySizes
        ? c()
        : a.addEventListener('lazyunveilread', c, !0);
  })(window, function (a, b, c) {
    function d(b, c) {
      let d;
      let e;
      let f;
      let g;
      const h = a.getComputedStyle(b);
      (e = b.parentNode),
        (g = { isPicture: !(!e || !m.test(e.nodeName || '')) }),
        (f = function (a, c) {
          let d = b.getAttribute(`data-${a}`);
          if (!d) {
            const e = h.getPropertyValue(`--ls-${a}`);
            e && (d = e.trim());
          }
          if (d) {
            if (d == 'true') d = !0;
            else if (d == 'false') d = !1;
            else if (l.test(d)) d = parseFloat(d);
            else if (typeof j[a] === 'function') d = j[a](b, d);
            else if (q.test(d))
              try {
                d = JSON.parse(d);
              } catch (a) {}
            g[a] = d;
          } else
            a in j && typeof j[a] !== 'function'
              ? (g[a] = j[a])
              : c && typeof j[a] === 'function' && (g[a] = j[a](b, d));
        });
      for (d in j) f(d);
      return (
        c.replace(p, function (a, b) {
          b in g || f(b, !0);
        }),
        g
      );
    }
    function e(a, b) {
      const c = [];
      const d = function (a, c) {
        return k[typeof b[c]] ? b[c] : a;
      };
      return (
        (c.srcset = []),
        b.absUrl && (s.setAttribute('href', a), (a = s.href)),
        (a = ((b.prefix || '') + a + (b.postfix || '')).replace(p, d)),
        b.widths.forEach(function (d) {
          const e = b.widthmap[d] || d;
          const f = b.aspectratio || b.ratio;
          const g = !b.aspectratio && j.traditionalRatio;
          const h = {
            u: a.replace(n, e).replace(o, f ? (g ? Math.round(d * f) : Math.round(d / f)) : ''),
            w: d,
          };
          c.push(h), c.srcset.push((h.c = `${h.u} ${d}w`));
        }),
        c
      );
    }
    function f(a, c, d) {
      let f = 0;
      let g = 0;
      let h = d;
      if (a) {
        if (c.ratio === 'container') {
          for (f = h.scrollWidth, g = h.scrollHeight; !((f && g) || h === b); )
            (h = h.parentNode), (f = h.scrollWidth), (g = h.scrollHeight);
          f && g && (c.ratio = g / f);
        }
        (a = e(a, c)),
          (a.isPicture = c.isPicture),
          u && d.nodeName.toUpperCase() == 'IMG'
            ? d.removeAttribute(i.srcsetAttr)
            : d.setAttribute(i.srcsetAttr, a.srcset.join(', ')),
          Object.defineProperty(d, '_lazyrias', { value: a, writable: !0 });
      }
    }
    function g(a, b) {
      const e = d(a, b);
      return (
        j.modifyOptions.call(a, { target: a, details: e, detail: e }),
        c.fire(a, 'lazyriasmodifyoptions', e),
        e
      );
    }
    function h(a) {
      return (
        a.getAttribute(a.getAttribute('data-srcattr') || j.srcAttr) ||
        a.getAttribute(i.srcsetAttr) ||
        a.getAttribute(i.srcAttr) ||
        a.getAttribute('data-pfsrcset') ||
        ''
      );
    }
    let i;
    let j;
    var k = { string: 1, number: 1 };
    var l = /^\-*\+*\d+\.*\d*$/;
    var m = /^picture$/i;
    var n = /\s*\{\s*width\s*\}\s*/i;
    var o = /\s*\{\s*height\s*\}\s*/i;
    var p = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi;
    var q = /^\[.*\]|\{.*\}$/;
    const r = /^(?:auto|\d+(px)?)$/;
    var s = b.createElement('a');
    const t = b.createElement('img');
    var u = 'srcset' in t && !('sizes' in t);
    const v = !!a.HTMLPictureElement && !u;
    !(function () {
      let b;
      const d = function () {};
      const e = {
        prefix: '',
        postfix: '',
        srcAttr: 'data-src',
        absUrl: !1,
        modifyOptions: d,
        widthmap: {},
        ratio: !1,
        traditionalRatio: !1,
        aspectratio: !1,
      };
      (i = (c && c.cfg) || a.lazySizesConfig),
        i || ((i = {}), (a.lazySizesConfig = i)),
        i.supportsType ||
          (i.supportsType = function (a) {
            return !a;
          }),
        i.rias || (i.rias = {}),
        'widths' in (j = i.rias) ||
          ((j.widths = []),
          (function (a) {
            for (var b, c = 0; !b || b < 3e3; )
              (c += 5), c > 30 && (c += 1), (b = 36 * c), a.push(b);
          })(j.widths));
      for (b in e) b in j || (j[b] = e[b]);
    })(),
      addEventListener(
        'lazybeforesizes',
        function (a) {
          if (a.detail.instance == c) {
            let b;
            let d;
            let e;
            let k;
            let l;
            let m;
            let o;
            let p;
            let q;
            let s;
            let t;
            let u;
            let x;
            if (
              ((b = a.target),
              a.detail.dataAttr &&
                !a.defaultPrevented &&
                !j.disabled &&
                (q = b.getAttribute(i.sizesAttr) || b.getAttribute('sizes')) &&
                r.test(q))
            ) {
              if (
                ((d = h(b)),
                (e = g(b, d)),
                (t = n.test(e.prefix) || n.test(e.postfix)),
                e.isPicture && (k = b.parentNode))
              )
                for (l = k.getElementsByTagName('source'), m = 0, o = l.length; m < o; m++)
                  (t || n.test((p = h(l[m])))) && (f(p, e, l[m]), (u = !0));
              t || n.test(d)
                ? (f(d, e, b), (u = !0))
                : u &&
                  ((x = []),
                  (x.srcset = []),
                  (x.isPicture = !0),
                  Object.defineProperty(b, '_lazyrias', { value: x, writable: !0 })),
                u &&
                  (v
                    ? b.removeAttribute(i.srcAttr)
                    : q != 'auto' &&
                      ((s = { width: parseInt(q, 10) }), w({ target: b, detail: s })));
            }
          }
        },
        !0
      );
    var w = (function () {
      const d = function (a, b) {
        return a.w - b.w;
      };
      const e = function (a) {
        let b;
        let c;
        const d = a.length;
        let e = a[d - 1];
        let f = 0;
        for (f; f < d; f++)
          if (((e = a[f]), (e.d = e.w / a.w), e.d >= a.d)) {
            !e.cached &&
              (b = a[f - 1]) &&
              b.d > a.d - 0.13 * a.d ** 2.2 &&
              ((c = (b.d - 0.6) ** 1.6),
              b.cached && (b.d += 0.15 * c),
              b.d + (e.d - a.d) * c > a.d && (e = b));
            break;
          }
        return e;
      };
      const f = function (a, b) {
        let d;
        return (
          !a._lazyrias &&
            c.pWS &&
            (d = c.pWS(a.getAttribute(i.srcsetAttr || ''))).length &&
            (Object.defineProperty(a, '_lazyrias', { value: d, writable: !0 }),
            b && a.parentNode && (d.isPicture = a.parentNode.nodeName.toUpperCase() == 'PICTURE')),
          a._lazyrias
        );
      };
      const g = function (b) {
        const d = a.devicePixelRatio || 1;
        const e = c.getX && c.getX(b);
        return Math.min(e || d, 2.4, d);
      };
      const h = function (b, c) {
        let h;
        let i;
        let j;
        let k;
        let l;
        let m;
        if (((l = b._lazyrias), l.isPicture && a.matchMedia))
          for (i = 0, h = b.parentNode.getElementsByTagName('source'), j = h.length; i < j; i++)
            if (
              f(h[i]) &&
              !h[i].getAttribute('type') &&
              (!(k = h[i].getAttribute('media')) || (matchMedia(k) || {}).matches)
            ) {
              l = h[i]._lazyrias;
              break;
            }
        return (!l.w || l.w < c) && ((l.w = c), (l.d = g(b)), (m = e(l.sort(d)))), m;
      };
      var j = function (d) {
        if (d.detail.instance == c) {
          let e;
          const g = d.target;
          if (!u && (a.respimage || a.picturefill || lazySizesConfig.pf))
            return void b.removeEventListener('lazybeforesizes', j);
          ('_lazyrias' in g || (d.detail.dataAttr && f(g, !0))) &&
            (e = h(g, d.detail.width)) &&
            e.u &&
            g._lazyrias.cur != e.u &&
            ((g._lazyrias.cur = e.u),
            (e.cached = !0),
            c.rAF(function () {
              g.setAttribute(i.srcAttr, e.u), g.setAttribute('src', e.u);
            }));
        }
      };
      return v ? (j = function () {}) : addEventListener('lazybeforesizes', j), j;
    })();
  });
}

// prettier-ignore
String.prototype.includes||(String.prototype.includes=function(){
return String.prototype.indexOf.apply(this,arguments)!==-1}),Array.prototype.includes||Object.defineProperty(Array.prototype,"includes",{value(t,r){if(this==null)throw new TypeError('"this" is null or not defined');const e=Object(this); const n=e.length>>>0;if(n===0)return!1;for(let i=0|r,o=Math.max(i>=0?i:n-Math.abs(i),0);o<n;){if(e[o]===t)return!0;o++}return!1}});

// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings'))
  theme.settings.predictiveSearchEnabled = false;
// Override Settings

const boostPFSFilterConfig = {
  general: {
    limit: window.COLLECTION_LOAD_LIMIT || boostPFSThemeConfig.custom.products_per_page,
    /* Optional */
    loadProductFirst: false,
    // Placeholder
    showPlaceholderProductList: true,
    placeholderProductPerRow: 3,
    placeholderProductGridItemClass:
      'boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-3 boost-pfs-filter-grid-width-mb-2',
    enableOTP: true,
    aspect_ratio: boostPFSThemeConfig.custom.aspect_ratio,
    cropImagePossitionEqualHeight: boostPFSThemeConfig.custom.product_img_crop,
    defaultDisplay: boostPFSThemeConfig.custom.product_item_type,
    selectOptionContainer: '.boost-pfs-filter-product-item-image', // CSS selector to append the product option, if left empty it will append to the product item
    // possibly old properties, copied from current
    separateRefineByFromFilter: true,
    filterTreeMobileStyle: 'style3', // 'style2', 'style3',
    equal_height: boostPFSThemeConfig.custom.equal_height,
    cropImagePossitionEqualHeight: boostPFSThemeConfig.custom.equal_height_crop_image_position,
    paginationTypeAdvanced: false,
    optionColorName: 'color',
    filterOptionColorId: 'pf_t_color',
  },
  selector: {
    otpButtons: '.boost-pfs-filter-product-item-image',
  },
};

let selectedColors = [];

function initColorButtons() {
  const colorOptionSection = document.querySelector('.boost-pfs-filter-option-color');
  const buttons =
    colorOptionSection && colorOptionSection.querySelectorAll('.boost-pfs-filter-option-item');

  buttons && buttons.forEach((wrapper) => {
    const button = wrapper.children[0];
    button.addEventListener('click', (e) => {
      const target = e.currentTarget;
      const color = target.dataset.handle;
      updateSelectedColors(color);
    });
  });

  //Hide Sold Out Colors
}

function initColorClear() {
  const colorOptionSection = document.querySelector('.boost-pfs-filter-option-color');
  const clear = colorOptionSection && colorOptionSection.querySelector('.boost-pfs-filter-clear');

  clear && clear.addEventListener('click', () => {
    selectedColors = [];
    // it wipes the DOM so need to reinit event listeners
    setTimeout(initColorButtons, 1000);
    setTimeout(initColorClear, 1000);
  });
}

function initYotpoReviews(){
  if (typeof yotpoWidgetsContainer != 'undefined' && yotpoWidgetsContainer) {
    yotpoWidgetsContainer.initWidgets();
    var api = new Yotpo.API(yotpo);
    api.refreshWidgets();
  }  
}

setTimeout(initColorButtons, 2500);
setTimeout(initColorClear, 2500);
setTimeout(initYotpoReviews, 2500);

function updateSelectedColors(color) {
  if (selectedColors.includes(color)) {
    selectedColors = selectedColors.filter((colr) => {
      return color !== colr;
    });
    return;
  }
  selectedColors.push(color);
  return;
}

let variantCount = 0;

(function () {
  let hasInit = false;
  /**** handles lifestyle cards injection **/
  const lifestyleCards = document.querySelectorAll('.LifestyleCard');
  const lifestyleCardsData = {};

  // eg {
  // 3: node,
  // 7: node,
  //  }

  if (lifestyleCards) {
    lifestyleCards.forEach((card) => {
      const { collectionCardPosition } = card.dataset || {};
      if (collectionCardPosition) {
        lifestyleCardsData[parseInt(collectionCardPosition)] = card;
      }
    });
  }
  /*****************************************/
  let onSale = false;
  let soldOut = false;
  let priceVaries = false;
  let images = [];
  let firstVariant = {};
  const boostPFSImgDefaultSrc =
    'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
  const boostPFSRangeWidths = [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048];

  BoostPFS.inject(this);
  // boostPFSFilterConfig.general.separateRefineByFromFilter =
  //   jQ('.boost-pfs-filter-tree-h').length &&
  //   !Utils.isMobile() > 0 &&
  //   boostPFSThemeConfig.custom.filter_tree_horizontal_style != 'style-expand'
  //     ? true
  //     : false;
  // Selector.stickyElementDesktop = jQ('.boost-pfs-filter-tree-v').length > 0 && !Utils.isMobile() ?  '.boost-pfs-filter-left-col' : '.boost-pfs-filter-tree';

  /* Handleize */
  function handleize(str = '') {
    return str
      .toLowerCase()
      .replace(/[^\w\u00C0-\u024f]+/g, '')
      .replace(/^-+|-+$/g, '')
      .replace(/[^-]+-$/, '');
  }

  /** ************************ CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM ************************* */
  function prepareShopifyData(data) {
    // Displaying price base on the policy of Shopify, have to multiple by 100
    soldOut = !data.available; // Check a product is out of stock
    onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Convert images to array
    images = data.images_info;
    // Get First Variant (selected_or_first_available_variant)
    firstVariant = data.variants[0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      const paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam('variant');
      });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      for (let i = 0; i < data.variants.length; i++) {
        if (data.variants[i].available) {
          firstVariant = data.variants[i];
          break;
        }
      }
    }
    return data;
  }

  /** ************************ BUILD PRODUCT VARIANT ITEMS ************************* */
  function buildVariantsItem(data, layout) {
    // console.log('running build variants item');
    let html = '';
    const template =
      layout === 'grid'
        ? boostPFSTemplate.productGridItemHtml
        : boostPFSTemplate.productListItemHtml;
    const hasProduct = boostPFSConfig.custom.split_products.includes(data.handle);
    // console.log('boostPFSConfig.custom.split_products', boostPFSConfig.custom.split_products);

    // console.log('boosPFSConfig', boostPFSConfig);
    if (boostPFSConfig.general.template !== 'collection.splice' && !hasProduct) return template;

    let { variants } = data;

    // console.log('originalVariants:', variants);
    if (boostPFSConfig.custom.split_variants.length > 0) {
      const filteredVariants = data.variants.filter(function (variant) {
        return boostPFSConfig.custom.split_variants.includes(`${data.handle}:${variant.id}`);
      });

      if (filteredVariants.length > 0) variants = filteredVariants;
    }

    // console.log('filteredVariants:', variants);

    const colors = [];
    const option = `option_${boostPFSFilterConfig.general.optionColorName}`;

    for (let i = 0; i < variants.length; i++) {
      var variant = variants[i];
      // console.log('variant', data.handle, '', variant.title);

      var color = variant[option];
      if (color && colors.indexOf(color) === -1) {
        colors.push(color);
        // console.log(color);

        let variantImages = [];

        if (Globals.queryParams.hasOwnProperty(boostPFSFilterConfig.general.filterOptionColorId)) {
          // if (Globals.queryParams[boostPFSFilterConfig.general.filterOptionColorId].indexOf(color) === -1) continue;
          const value = Utils.getProductMetafield(data, variant.id, 'variant_color_tag');
          if (!value) continue;
          const color_values = value.split('|');
          let value_found = false;
          for (let n = 0; n < color_values.length; n++) {
            const v = color_values[n];
            if (
              Globals.queryParams[boostPFSFilterConfig.general.filterOptionColorId].indexOf(v) > -1
            ) {
              value_found = true;
            }
          }

          // console.log(
          //   data.title,
          //   variant.title,
          //   'metafield:',
          //   color_values,
          //   Globals.queryParams[boostPFSFilterConfig.general.filterOptionColorId],
          //   value_found
          // );

          if (!value_found) continue;
        }

        if (variant.image) {
          var image = data.images_info.find(function (image) {
            return image.src === variant.image;
          });
          const secondImages = data.images_info.filter(function (img) {
            return img.alt && image.alt && image.alt.indexOf(img.alt) != -1;
          });

          let secondImage = '';
          for (let idx = 0; idx < secondImages.length; idx++) {
            if (
              secondImages[idx] &&
              secondImages[idx].id &&
              image.id != secondImages[idx].id &&
              secondImage == ''
            ) {
              secondImage = secondImages[idx];
            }
          }

          if (secondImage) {
            variantImages = [image, secondImage];
          } else {
            variantImages = [image, image];
          }
        }

        if (!variant.available) {
          const avalvar = data.variants.find(function (v) {
            return v[option] === color && v.available;
          });
          if (avalvar) variant = avalvar;
        }

        if (!variant.available) continue;

        // Get Template
        let itemHtml = template;

        /** Variants replace Code */

        // Images
        if (variantImages.length > 0) {
          images = variantImages.concat(images);
          // console.log('variantImages', variantImages);
          itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data, true));
          itemHtml = itemHtml.replace(/{{itemQuickAdd}}/g, buildQuickAdd(data, variant));
          images = data.images_info;
        }

        // Add Price
        onSale = variant.compare_at_price > variant.price;
        priceVaries = false;

        const priceData = {
          compare_at_price_min: variant.compare_at_price,
          price_min: variant.price,
        };

        itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(priceData));

        // Add Custom class
        const soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
        const saleClass = onSale ? boostPFSTemplate.saleClass : '';

        itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
        itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
        // Add Label
        itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));

        // console.log('data:', data, 'variant:', variant);
        itemHtml = itemHtml.replace(
          /{{itemUrl}}/g,
          `${Utils.buildProductItemUrl(data)}?variant=${variant.id}`
        );
        const showVariantTitle = false;
        if (showVariantTitle) {
          itemHtml = itemHtml.replace(
            /{{itemTitle}}/g,
            `${data.title}<span class="variant-color">${Utils.capitalize(color)}</span>`
          );
        } else {
          itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
        }
        const lifestyleCard = createInterstitialCard(variantCount, lifestyleCardsData);
        if (lifestyleCard) {
          itemHtml = lifestyleCard + itemHtml
        }
        variantCount++;

        html += itemHtml;
      }
    }

    if (!html) html = template;

    return html;
  }

  /** ************************ BUILD PRODUCT LIST ************************* */
  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (data) {
    // get data for interstitial cards

    const itemIndex = this.index;
    const totalProducts = this.totalProduct;

    if (!data) data = this.data;
    // Customize API data to get the Shopify data
    data = prepareShopifyData(data); // data is related to the individual product here

    // Get Template
    // var itemHtml = boostPFSTemplate.productGridItemHtml;
    let itemHtml = buildVariantsItem(data, 'grid');
    // Add Custom class
    const soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
    const saleClass = onSale ? boostPFSTemplate.saleClass : '';

    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
    // Add Grid Width class
    itemHtml = itemHtml.replace(/{{gridWidthClass}}/g, buildGridWidthClass(data));
    // Add Label
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
    // Add TAG Label
    itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
    // Add Promo Message
    itemHtml = itemHtml.replace(/{{itemPromoMessage}}/g, buildPromoMessage(data));
    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
    // Add Quick Add
    itemHtml = itemHtml.replace(/{{itemQuickAdd}}/g, buildQuickAdd(data));
    // Add Price
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));

    // Add Review
    if (
      typeof Integration === 'undefined' ||
      (typeof Integration !== 'undefined' &&
        typeof Integration.hascompileTemplate === 'function' &&
        !Integration.hascompileTemplate('reviews'))
    ) {
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
    }

    
    // Add Yotpo Reviews
    itemHtml = itemHtml.replace(/{{itemYotpoReviews}}/g, buildYotpoReview(data));
    
    // Add Vendor
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

    // itemActiveSwapClass
    itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, buildActiveSwapClass(data));

    // Add Color Swatches
    // itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildProductOptionSwatches(data));
    itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildColorSwatches(data));
    // if (data.options.indexOf('color') > -1) {
    //   console.log('colorSwatches', data.options, buildColorSwatches(data));
    //   itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildColorSwatches(data));
    // } else {
    //   itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, '');
    // }

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    // itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, buildUrlOnColorFilter(data));

    return itemHtml;
  };

  function buildUrlOnColorFilter(data) {
    const base = Utils.buildProductItemUrl(data);
    const currColor = getCurrentColor();
    if (!currColor) return base;

    // get primary variant id after color filter
    const variantIds = data.metafields
      .filter((metafield) => {
        return metafield.key === 'variant_color_tag' && metafield.value.includes(currColor);
      })
      .map((metafield) => metafield.id);
    if (variantIds.length === 0) return base;
    return `${base}?variant=${variantIds[0]}`;
  }

  function createInterstitialCard(itemIndex, data = {}) {
    if (Object.keys(data) === 0) return;
    let html;
    if (data[itemIndex + 1]) {
      html = data[itemIndex + 1].outerHTML;
    }

    return html;
  }

  // Build Product List Item
  ProductListItem.prototype.compileTemplate = function (data) {
    // console.log('buiding list item');
    if (!data) data = this.data;
    // Customize API data to get the Shopify data
    data = prepareShopifyData(data);

    // For List View
    // Get Template
    // var itemHtml = boostPFSTemplate.productListItemHtml;
    let itemHtml = buildVariantsItem(data, 'list');

    // Add Custom class
    const soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
    const saleClass = onSale ? boostPFSTemplate.saleClass : '';

    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
    // Add Label
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
    // Add TAG Label
    itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));

    // Add Review
    if (
      typeof Integration === 'undefined' ||
      (typeof Integration !== 'undefined' &&
        typeof Integration.hascompileTemplate === 'function' &&
        !Integration.hascompileTemplate('reviews'))
    ) {
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
    }

    // Add Vendor
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

    // Add Price
    const itemPriceHtml = buildPrice(data, onSale, priceVaries);
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Description
    var itemDescription = '';
    if (data.body_html != null) {
      var itemDescription = jQ(`<p>${data.body_html}</p>`).text();
      itemDescription =
        itemDescription.split(' ').length > 35
          ? `${itemDescription.split(' ').splice(0, 35).join(' ')}...`
          : itemDescription.split(' ').splice(0, 35).join(' ');
    }
    itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);

    // itemActiveSwapClass
    itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, buildActiveSwapClass(data));

    // Add Color Swatches
    // itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildProductOptionSwatches(data));
    itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildColorSwatches(data));

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    // itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);

    return itemHtml;
    // End For List View
  };

  /** ************************ END BUILD PRODUCT LIST ************************* */
  /** ************************ BUILD PRODUCT ITEM ELEMENTS ************************* */
  function buildGridWidthClass() {
    let gridWidthClass = '';
    // On PC
    switch (boostPFSThemeConfig.custom.products_per_row) {
      case 2:
        gridWidthClass = 'boost-pfs-filter-grid-width-2';
        break;
      case 3:
        gridWidthClass = 'boost-pfs-filter-grid-width-3';
        break;
      case 5:
        gridWidthClass = 'boost-pfs-filter-grid-width-5';
        break;
      case 6:
        gridWidthClass = 'boost-pfs-filter-grid-width-6';
        break;
      default:
        gridWidthClass = 'boost-pfs-filter-grid-width-4';
        break;
    }
    // On Mobile
    switch (boostPFSThemeConfig.custom.products_per_row_m) {
      case 1:
        gridWidthClass += ' boost-pfs-filter-grid-width-mb-1';
        break;
      case 3:
        gridWidthClass += ' boost-pfs-filter-grid-width-mb-3';
        break;
      default:
        gridWidthClass += ' boost-pfs-filter-grid-width-mb-2';
        break;
    }
    return gridWidthClass;
  }

  function getVariantImage(color, data) {
    const variantNamespaceArray = data.metafields.filter(function (m) {
      const valueArray = m.value.split('|');
      if (m.key == 'variant_color_tag' && valueArray.indexOf(color) > -1) return m;
    })[0];
    if (variantNamespaceArray) {
      var variantNamespace = variantNamespaceArray.namespace;
    }
    const variant = data.variants.filter(function (v) {
      if (v.id == variantNamespace) return v;
    })[0];
    if (variant) {
      return variant.image;
    }
  }

  function buildImages(data, isVariantImage = false) {

    let secondFirst = false;
    if (data.tags.includes('ABTest')){
      secondFirst = true;
    }
    // first filter the available images by color data
    // if no color has been set, we return the full array of images
    // the images variable is in scope
    const filteredImages = filterImagesForColor(data, images);

    if (Globals.queryParams[boostPFSFilterConfig.general.filterOptionColorId] && !isVariantImage) {
      var variantImage = getVariantImage(
        Globals.queryParams[boostPFSFilterConfig.general.filterOptionColorId][0],
        data
      );
    }
    let html = '';
    let aspectRatio = '';
    const rangeWidths = boostPFSRangeWidths;
    let paddingTop = 100;

    let dataSrcSet = '';
    let dataWidths = '';
    const dataSizes = 'auto';
    const imgAlt = data.title;
    let flipImageSrcSet = '';

    const activeSwapImage =
      !Utils.isMobile() &&
      filteredImages.length > 1 &&
      boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
      boostPFSThemeConfig.custom.active_image_swap == true;


    if (!secondFirst){
      for (let i = 0; i < rangeWidths.length; i++) {
        dataSrcSet += `${Utils.getFeaturedImage(filteredImages, `${rangeWidths[i]}x`)} ${
          rangeWidths[i]
        }w`;
  
        if (variantImage) {
          dataSrcSet = variantImage;
        }
        dataWidths += rangeWidths[i];
  
        if (activeSwapImage) {
          flipImageSrcSet += `${Utils.optimizeImage(filteredImages[1].src, `${rangeWidths[i]}x`)} ${
            rangeWidths[i]
          }w`;
          if (variantImage) {
            const variantImageObject = filteredImages.filter(function (i) {
              if (i.src == variantImage) {
                return i;
              }
            })[0];
            const variantImageIndex = filteredImages.indexOf(variantImageObject);
            var variantFlipImage = filteredImages[variantImageIndex + 1];
            if (variantFlipImage) {
              flipImageSrcSet += `${Utils.optimizeImage(
                variantFlipImage.src,
                `${rangeWidths[i]}x`
              )} ${rangeWidths[i]}w`;
            }
          }
        }
  
        if (i < rangeWidths.length - 1) {
          dataSrcSet += ', ';
          dataWidths += ', ';
  
          if (activeSwapImage) {
            flipImageSrcSet += ', ';
          }
        }
      }  
    } else{
      for (let i = 0; i < rangeWidths.length; i++) {
        dataSrcSet += `${Utils.optimizeImage(filteredImages[1].src, `${rangeWidths[i]}x`)} ${
          rangeWidths[i]
        }w`;
  
        if (variantImage) {
          dataSrcSet = variantImage;
        }
        dataWidths += rangeWidths[i];
  
        if (activeSwapImage) {
          flipImageSrcSet += `${Utils.optimizeImage(filteredImages[0].src, `${rangeWidths[i]}x`)} ${
            rangeWidths[i]
          }w`;
          if (variantImage) {
            const variantImageObject = filteredImages.filter(function (i) {
              if (i.src == variantImage) {
                return i;
              }
            })[0];
            const variantImageIndex = filteredImages.indexOf(variantImageObject);
            var variantFlipImage = filteredImages[variantImageIndex + 1];
            if (variantFlipImage) {
              flipImageSrcSet += `${Utils.optimizeImage(
                variantFlipImage.src,
                `${rangeWidths[i]}x`
              )} ${rangeWidths[i]}w`;
            }
          }
        }
  
        if (i < rangeWidths.length - 1) {
          dataSrcSet += ', ';
          dataWidths += ', ';
  
          if (activeSwapImage) {
            flipImageSrcSet += ', ';
          }
        }
      }  
    }

    if (filteredImages.length > 0) {
      aspectRatio = filteredImages[0].width / filteredImages[0].height;
      paddingTop = (1 / aspectRatio) * 100;
    }

    if (!secondFirst){
      html += '<a href="{{itemUrl}}" class="boost-pfs-filter-product-item-image-link" ';
      html += `style="padding-top:${paddingTop}%;">`;
      html +=
        `<img class="boost-pfs-filter-product-item-main-image lazyload Image--lazyLoad"` +
        `data-srcset="${dataSrcSet}" ` +
        `data-src="${Utils.getFeaturedImage(filteredImages, `${rangeWidths[2]}x`)}" ` +
        `data-widths="[${dataWidths}]" ` +
        `data-sizes="${dataSizes}" ` +
        `src="${boostPFSImgDefaultSrc}" ` +
        `alt="${imgAlt}"  `;
  
      // if (activeSwapImage) {
      //   html += ' data-img-flip-src="' + Utils.optimizeImage(images[1]['src'], rangeWidths[2] + 'x') + '" ' +
      //     'data-img-flip-srcset="' + flipImageSrcSet + '" ';
      // }
      if (activeSwapImage) {
        let flipImage;
        if (variantFlipImage) {
          flipImage = Utils.optimizeImage(variantFlipImage.src, `${rangeWidths[2]}x`);
        } else {
          flipImage = Utils.optimizeImage(filteredImages[1].src, `${rangeWidths[2]}x`);
        }
        html += `data-img-flip-src="${flipImage}" ` + `data-img-flip-srcset="${flipImageSrcSet}" `;
      }
      html += '/></a>';
    } else{
      // console.log('first image ' + filteredImages[1].src)
      // console.log('second image ' + filteredImages[0].src)
      let firstImage;
      if (variantFlipImage) {
        firstImage = Utils.optimizeImage(variantFlipImage.src, `${rangeWidths[2]}x`);
      } else {
        firstImage = Utils.optimizeImage(filteredImages[1].src, `${rangeWidths[2]}x`);
      }

      html += '<a href="{{itemUrl}}" class="boost-pfs-filter-product-item-image-link" ';
      html += `style="padding-top:${paddingTop}%;">`;
      html +=
        `<img class="boost-pfs-filter-product-item-main-image ab-test lazyload Image--lazyLoad"` +
        `data-srcset="${dataSrcSet}" ` +
        `data-src="${firstImage}" ` +
        `data-widths="[${dataWidths}]" ` +
        `data-sizes="${dataSizes}" ` +
        `src="${firstImage}" ` +
        `alt="${imgAlt}"  `;
  
      // if (activeSwapImage) {
      //   html += ' data-img-flip-src="' + Utils.optimizeImage(images[1]['src'], rangeWidths[2] + 'x') + '" ' +
      //     'data-img-flip-srcset="' + flipImageSrcSet + '" ';
      // }
      if (activeSwapImage) {
        let flipImage = Utils.optimizeImage(filteredImages[0].src, `${rangeWidths[2]}x`);
        html += `data-img-flip-src="${flipImage}" ` + `data-img-flip-srcset="${flipImageSrcSet}" `;
      }
      html += '/></a>';
    }

    return html;
  }

  function filterVariantsByColor(data) {
    // filter variants by color
    // used for quick add
    const currColor = getCurrentColor();
    if (!currColor) return data.variants;

    const variantIds = data.metafields
      .filter((metafield) => {
        return metafield.key === 'variant_color_tag' && metafield.value.includes(currColor);
      })
      .map((metafield) => metafield.id);

    const filtered = data.variants.filter((variant) => {
      return variantIds.includes(variant.id);
    });

    return filtered;
  }

  function buildQuickAdd(data, variant = false) {
    if (data.available === false) return '';
    let quickAddCount = 0;
    const filteredVariants = filterVariantsByColor(data);
    if (filteredVariants.length === 0) return '';
    // console.log('filtered variants', filteredVariants);
    const numOfVariants = filteredVariants.length;
    const availableVariant = variant || filteredVariants[0];
    if (!availableVariant.option2) return '';
    const initialHtml = '<div class="QuickAdd">';
    let html = initialHtml;

    for (const v in filteredVariants) {
      // loop through each variant and add quick add buttons
      // these will either be the first available, or variants that have been filtered by color
      var variant = filteredVariants[v];
      if (variant.available && variant.option2) {
        if (variant.option1 == availableVariant.option1) {
          quickAddCount += 1;
          if (quickAddCount) {
            html += '<button ';
            html += 'class="QuickAdd-button button text"';
            html += `data-variant-id="${variant.id}"`;
            html += `data-option-name="${variant.option_size}"`;
            html += 'data-variant-quantity="1"';
            html += 'data-add-to-cart ';
            html += `aria-label="Quick-Add Size ${variant.option_size} To Cart"`;
            if(variant.available) {
            } else {
              html += 'disabled'
            }
            html += '>';
            if (numOfVariants === 1 || !variant.option2) {
              html += 'Add to Cart';
            } else {
              html += variant.option2;
            }
            html += '</button>';
          }
        }
      }
    }
    // if nothing has been added, we don't return an empty div
    if (html === initialHtml) return '';
    html += '</div>';
    return html;
  }

  function buildVendor() {
    let html = '';
    if (
      boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') &&
      boostPFSThemeConfig.custom.show_vendor == true
    ) {
      html = boostPFSTemplate.vendorHtml;
    }
    return html;
  }

  function buildYotpoReview({id}) {
    let html = `<div class='product-rating-wrapper'><div class="yotpo bottomLine yotpo-collection" data-product-id="${id}"></div></div>`;
    return html;
  }

  function buildPrice(data) {
    let html = '';
    if (
      boostPFSThemeConfig.custom.hasOwnProperty('show_price') &&
      boostPFSThemeConfig.custom.show_price
    ) {
      html = '<p class="ProductCard-price">';
      if (onSale) {
        html += `<span class="boost-pfs-filter-product-item-sale-price">${
          Utils.formatMoney(data.price_min).split('.')[0]
        }</span>`;
        html += `<s>${Utils.formatMoney(data.compare_at_price_min).split('.')[0]}</s> `;
      } else {
        if (priceVaries) {
          html +=
            `<span class="boost-pfs-filter-product-item-price-from-text">${boostPFSThemeConfig.label_basic.from} ` +
            `</span>`;
        }
        html += `<span class="boost-pfs-filter-product-item-regular-price">${
          Utils.formatMoney(data.price_min).split('.')[0]
        }</span>`;
      }
      html += '</p>';
    }
    return html;
  }

  function buildLabels(data) {
    // Build all labels
    let soldOutLabel = '';
    if (
      boostPFSThemeConfig.custom.hasOwnProperty('sold_out_enable') &&
      boostPFSThemeConfig.custom.sold_out_enable &&
      soldOut
    ) {
      soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{style}}/g, '');
    }
    // Build Sale label
    let saleLabel = '';
    let salePercent = '';
    if (boostPFSThemeConfig.custom.sale_label_enable && onSale && !soldOut) {
      if (boostPFSThemeConfig.custom.sale_label_display == 'sale_percent') {
        salePercent = Math.round(
          ((data.compare_at_price_min - data.price_min) * 100) / data.compare_at_price_max
        );
      }
      saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{style}}/g, '');
      saleLabel = boostPFSTemplate.saleLabelHtml.replace(/percent/g, `-${salePercent}%`);
    }
    // Build Labels
    return soldOutLabel + saleLabel;
  }

  // BUILD LABEL PRODUCT WITH TAGS
  function buildTagLabels(data, showall) {
    // console.log('running build tag labels', boostPFSThemeConfig.custom.tag_label_enable);
    if (boostPFSThemeConfig.custom.tag_label_enable) {
      if (showall) {
        var tagLabel = '';
        if (data.tags) {
          for (var i = 0; i < data.tags.length; i++) {
            var tag = data.tags[i];
            if (tag.indexOf('pfs:label') !== -1) {
              var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(
                /{{labelTag}}/g,
                tag.split('pfs:label-')[1]
              );
              tagLabel += preTagLabel;
            }
          }
        }
      } else {
        var tagLabel = '';
        if (data.tags) {
          for (var i = data.tags.length - 1; i >= 0; i--) {
            tag = data.tags[i];

            if (tag.indexOf('pfs:label') !== -1 || tag.indexOf('callout:') !== -1) {
              const toInsert = tag.split('pfs:label-')[1] || tag.split('callout:')[1];
              if (!toInsert) continue;
              var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, toInsert);
              tagLabel += preTagLabel;
              break;
            }
          }
        }
      }
      return tagLabel;
    }
    return '';
  }

  // BUILD PROMO Message
  function buildPromoMessage(data) {
    // console.log('running build tag labels', boostPFSThemeConfig.custom.tag_label_enable);
    if (window.sitewide_promo.enable_promo) {
        var tagLabel = '';
        var promo_text = window.sitewide_promo.promo_text;
        var promo_tag = window.sitewide_promo.promo_tag;

        if (data.tags) {
          for (var i = data.tags.length - 1; i >= 0; i--) {
            tag = data.tags[i];

            if (tag.indexOf(promo_tag) !== -1) {
              var preTagLabel = boostPFSTemplate.promoMessageHtml.replace(/{{labelTag}}/g, promo_text);
              tagLabel += preTagLabel;
              break;
            }
          }
        }
      return tagLabel;
    }
    return '';
  }

  // Build Color Swatches
  function buildColorSwatches(data) {

    const swatches_to_display = {};
    const variant_ids_for_color = {};
    const variant_stock = {};



    const color_option = data.options_with_values.filter(function (item) {
      if (item.name == 'color') {
        return item;
      }
    })[0];

    if (!color_option || !Array.isArray(color_option.values)) return '';

    color_option.values.forEach(function (value) {
      swatches_to_display[value.title] = false;
    });

    data.variants.forEach(function (variant) {
      const metafield = data.metafields.filter(function (meta) {
        if (
          meta.namespace == variant.id ||
          (meta.id == variant.id && meta.key == 'display_variant')
        ) {
          return meta;
        }
      })[0];

      if (variant_ids_for_color[variant.option_color]) {
        variant_ids_for_color[variant.option_color].push({ [variant.option_size]: variant.id });
      } else {
        variant_ids_for_color[variant.option_color] = [{ [variant.option_size]: variant.id }];
      }

      if (variant_stock[variant.option_color]) {
        variant_stock[variant.option_color].push({ [variant.option_size]: variant.available });
      } else {
        variant_stock[variant.option_color] = [{ [variant.option_size]: variant.available }];
      }

      if (metafield) {
        if (metafield.value == 'true') {
          swatches_to_display[variant.option_color] = true;
        }
      }
    });


    let colorSwatchesHtml = '';
    const filterSwatchTitle = 'Color';
    const optionName = 'color';
    let swatchArr = [];
    let countSwatch = 0;
    let swatchValues = [];
    let swatchLimit = 7;
    let swatchRemainder;

    const dataImgSize = '360';
    const bgSize = '50x';
    let dataImgSrc = Utils.getFeaturedImage(data.images_info, `${dataImgSize}x`);
    let dataFlipImgSrc;
    let swatchName = '#ffffff';
    let bgImageSrc = '';
    const viewMoreLabel = `More ${filterSwatchTitle}`;

    if (
      boostPFSThemeConfig.custom.hasOwnProperty('display_item_swatch') &&
      boostPFSThemeConfig.custom.display_item_swatch == true
    ) {
      if (typeof data.options_with_values !== 'undefined' && data.options_with_values.length > 0) {
        swatchArr = data.options_with_values.filter(function (option) {
          return option.name == optionName;
        });
        let swatchesToDisplayCount = 0;
        if (swatchArr.length > 0) {
          try {
            swatchesToDisplayCount = Object.keys(swatches_to_display).reduce((prev, curr) => {
              if (swatches_to_display[curr] === true) {
                return prev + 1;
              }
              return prev;
            }, 0);
          } catch (e) {
            console.error(e);
          }
          countSwatch = swatchArr[0].values.length;
          if (swatchLimit > countSwatch) {
            swatchLimit = countSwatch;
          }

          if (jQ(window).width() < 1500) {
            swatchLimit = 5;
          }

          if (jQ(window).width() < 1200) {
            swatchLimit = 3;
          }

          swatchRemainder =
            swatchesToDisplayCount === 0
              ? countSwatch - swatchLimit
              : swatchesToDisplayCount - swatchLimit;
          swatchValues = swatchArr[0].values;

          let s2dCount = 0;
          for (const s2d in swatches_to_display) {
            if (swatches_to_display[s2d]) {
              s2dCount += 1;
            }
          }

          colorSwatchesHtml += `<div class="ProductCard-swatchWrapper boost-pfs-filter-item-swatch-cover">`;

          colorSwatchesHtml += '<ul class="ProductCard-swatches boost-pfs-filter-item-swatch">';

          let endlessLoopCanceler = 0;
          let sIndex = 0;
          while (sIndex < swatchLimit && endlessLoopCanceler < swatchLimit) {
            if (!swatchValues[endlessLoopCanceler]) {
              break;
            }

            swatchName = swatchValues[endlessLoopCanceler].title;

            sImageIndex = swatchValues[endlessLoopCanceler].image || '';
            if (sImageIndex != '') {
              dataImgSrc = `${Utils.optimizeImage(
                data.images[sImageIndex],
                `${dataImgSize}x`
              )} ${dataImgSize}w`;
              dataFlipImgSrc = `${Utils.optimizeImage(
                data.images[sImageIndex + 1],
                `${dataImgSize}x`
              )} ${dataImgSize}w`;
              // qw12#1
            }

            if (boostPFSThemeConfig.custom.hasOwnProperty('swatch_color_display_type')) {
              switch (boostPFSThemeConfig.custom.swatch_color_display_type) {
                case 'swatch_color_display_type_image_color':
                  bgImageSrc = boostPFSAppConfig.general.file_url.replace(
                    /\?/,
                    `${Utils.slugify(filterSwatchTitle).replace(/\-/g, '_')}-${Utils.slugify(
                      swatchName
                    )}.png?v=`
                  );
                  break;
                case 'swatch_color_display_type_image_product':
                  bgImageSrc = Utils.getFeaturedImage(data.images_info, bgSize);
                  if (sImageIndex != '') {
                    bgImageSrc = Utils.optimizeImage(data.images[sImageIndex], bgSize);
                  }
                  break;
                default:
                  bgImageSrc = '';
              }
            }

            if (swatches_to_display[swatchName]) {
              let completely_sold_out
              if(data.tags.includes('sale')) {
                completely_sold_out = variant_stock[swatchName].every( obj => obj[Object.keys(obj)[0]] == false )
              } else {
                completely_sold_out = false
              }


              colorSwatchesHtml += `<li class="ProductCard-swatch" data-hide-me="${completely_sold_out}">`;
              colorSwatchesHtml += `<div class="boost-pfs-product-item-tooltip">${swatchName}</div>`;
              colorSwatchesHtml += `<span data-id="color-swatch-selector" class="ColorSwatch--${handleize(
                swatchName
              )} color-swatch-span" data-variant-ids='${JSON.stringify(
                variant_ids_for_color[swatchName]
              )}' data-variant-stock='${JSON.stringify(
                variant_stock[swatchName]
              )}' tabindex="0" aria-label="${swatchName}" `;
              if (dataImgSrc != '') {
                colorSwatchesHtml += `data-img="${dataImgSrc}" `;
              }
              if (dataFlipImgSrc != '') {
                colorSwatchesHtml += `data-flip-img="${dataFlipImgSrc}" `;
              }
              colorSwatchesHtml += '></span>';
              colorSwatchesHtml += '</li>';
              sIndex++;
            }
            endlessLoopCanceler++;
          }
          if (swatchesToDisplayCount > swatchLimit) {
            colorSwatchesHtml += '<li class="ProductCard-swatch ProductCard-swatch--more">';
            colorSwatchesHtml += `<a href="{{itemUrl}}" title="${viewMoreLabel}">+${swatchRemainder}</a>`;
            colorSwatchesHtml += '</li>';
          }
          colorSwatchesHtml += `<span class="ProductCard-swatch--total">${swatchesToDisplayCount} Colors Available</span>`;

          colorSwatchesHtml += '</ul></div>';
        }
      }
    }
    return colorSwatchesHtml;
  }

  function getCurrentColor() {
    // get the current color from the selectedColors array
    // selectedColors is already in scope
    if (selectedColors.length === 0) {
      return null;
    }
    return selectedColors[selectedColors.length - 1].toLowerCase();
  }

  function filterImagesForColor(data, images) {
    let variantId = null;
    if (selectedColors.length === 0) return images;

    // get the current filtered color
    const currColor = getCurrentColor();
    const variantMetaObj = data.metafields
      .filter((metafield) => {
        return metafield.key === 'variant_color_tag';
      })
      .find((metafield) => metafield.value === currColor);
    if (variantMetaObj) {
      variantId = variantMetaObj.id;
      const variant = data.variants.find((variant) => variant.id === variantId);
      if (variant) {
        const optionColor = variant.option_color.replace(/ /g, '');
        const filtered = images.filter((image) => {
          if (!image.alt) return false;
          const colorStr = image.alt.split('(')[1].split(')')[0];
          return colorStr === optionColor;
        });

        return filtered;
      }
    }

    return images;
  }

  function swappy(el) {
    const img = jQ(el)
      .parents('.boost-pfs-filter-product-item-inner')
      .find('.boost-pfs-filter-product-item-main-image');
    const flipImg = jQ(el)
      .parents('.boost-pfs-filter-product-item-inner')
      .find('.boost-pfs-filter-product-item-flip-image');
    const newImage = jQ(el).data('img');
    const newFlipImage = jQ(el).data('flip-img');
    img.attr('srcset', newImage);
    flipImg.attr('srcset', newFlipImage);

    const variantIds = jQ(el).data('variant-ids');
    const variantStock = jQ(el).data('variant-stock');
    const $quickAdd = jQ(el)
      .closest('.boost-pfs-filter-product-item')
      .find('.QuickAdd');

    for (const vi in variantIds) {
      const idObject = variantIds[vi];
      const stockObject = variantStock[vi];
      const size = Object.keys(idObject)[0];
      const id = idObject[size];
      const inStock = stockObject[size];

      $quickAdd.find(`[data-option-name="${size}"]`).data('variant-id', id);
      if(inStock) {
        if($quickAdd.find(`[data-option-name="${size}"]`).is(':disabled')) {
          $quickAdd.find(`[data-option-name="${size}"]`).prop("disabled", false);
        }
      } else {
        if($quickAdd.find(`[data-option-name="${size}"]`).is(':disabled')) {

        } else {
          $quickAdd.find(`[data-option-name="${size}"]`).prop("disabled", true);
        }
      }
    }
  }

  function eventColorSwatches(event) {
    // console.log('running event , event', event);
    jQ('.boost-pfs-filter-item-swatch li span').each(function () {
      const img = jQ(this)
        .parents('.boost-pfs-filter-product-item-inner')
        .find('.boost-pfs-filter-product-item-main-image');
      const flipImg = jQ(this)
        .parents('.boost-pfs-filter-product-item-inner')
        .find('.boost-pfs-filter-product-item-flip-image');

      if (event == 'hover') {
        jQ(this).hover(function () {
          swappy(this);
        });
      }
      if (event == 'click') {
        jQ(this).click(function () {
          const newImage = jQ(this).data('img');
          img.attr('srcset', newImage);
        });
      }
      jQ(this).focus(function () {
        if (jQ('body').hasClass('boost-pfs-ada')) {
          const newImage = jQ(this).data('img');
          img.attr('srcset', newImage);
        }
      });
    });
  }

  function buildReview(data) {
    let html = '';
    if (
      boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
      boostPFSThemeConfig.custom.show_product_review == true
    ) {
      html = '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
    }
    return html;
  }

  function buildActiveSwapClass(data) {
    if (
      !Utils.isMobile() &&
      images.length > 1 &&
      boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
      boostPFSThemeConfig.custom.active_image_swap == true
    ) {
      return 'has-bc-swap-image';
    }
    return '';
  }

  /** ************************ END BUILD PRODUCT ITEM ELEMENTS ************************* */
  /** ************************ BUILD TOOLBAR ************************* */
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    let currentPage = parseInt(Utils.stripHtml(Globals.queryParams.page));
    const totalPage = Math.ceil(totalProduct / Utils.stripHtml(Globals.queryParams.limit));
    if (!currentPage || isNaN(currentPage)) {
      currentPage = 1;
    }
    // If it has only one page, clear Pagination
    if (totalPage <= 1) {
      return '';
    }

    let paginationHtml = boostPFSTemplate.paginateHtml;
    // Build Previous
    let previousHtml =
      currentPage > 1 ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildToolbarLink('page', currentPage, currentPage - 1)
    );
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    let nextHtml =
      currentPage < totalPage ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildToolbarLink('page', currentPage, currentPage + 1)
    );
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    const beforeCurrentPageArr = [];
    for (let iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    const afterCurrentPageArr = [];
    for (let iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    let pageItemsHtml = '';
    const pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (let iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml +=
          pageArr[iPage] == currentPage
            ? boostPFSTemplate.pageItemSelectedHtml
            : boostPFSTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(
        /{{itemUrl}}/g,
        Utils.buildToolbarLink('page', currentPage, pageArr[iPage])
      );
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    return paginationHtml;
  };


  // don't show more lifestyle tiles on infinite scroll
  const originalAF = ProductPaginationInfinite.prototype._loadMoreProducts;
  ProductPaginationInfinite.prototype._loadMoreProducts = function () {
    variantCount = 10000000000000;
    originalAF.call(this)
  }

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    let html = '';
    // if (boostPFSThemeConfig.custom.show_sort_by && boostPFSTemplate.hasOwnProperty('sortingHtml')) {
    if (boostPFSThemeConfig.custom.show_sorting && boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      const sortingArr = Utils.getSortingList();
      if (sortingArr) {
        const paramSort = Utils.stripHtml(Globals.queryParams.sort) || '';
        // Build content
        let sortingItemsHtml = '';
        for (const k in sortingArr) {
          activeClass = '';
          if (paramSort == k) {
            activeClass = 'boost-pfs-filter-sort-item-active';
          }
          sortingItemsHtml += `<li aria-label="${sortingArr[k]}"><a href="#" data-sort="${k}" class="${activeClass}"  title="${sortingArr[k]}" aria-label="${sortingArr[k]}">${sortingArr[k]}</a></li>`;
        }
        html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      }
    }
    return html;
  };

  ProductSorting.prototype.render = function () {
    jQ(Selector.topSorting).html(this.compileTemplate());

    if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
      jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
    }

    let labelSort = '';
    const paramSort = Utils.stripHtml(Globals.queryParams.sort) || '';
    const sortingList = Utils.getSortingList();
    if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
      labelSort = sortingList[paramSort];
    } else {
      labelSort = Labels.sorting_heading;
    }

    jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
  };

  // Build Sorting event
  ProductSorting.prototype.bindEvents = function () {
    const _this = this;
    jQ('.boost-pfs-filter-filter-dropdown a').click(function (e) {
      e.preventDefault();
      FilterApi.setParam('sort', jQ(this).data('sort'));
      FilterApi.setParam('page', 1);
      FilterApi.applyFilter('sort');
    });

    jQ('.boost-pfs-filter-custom-sorting > button').click(function () {
      jQ('.boost-pfs-filter-filter-dropdown')
        .toggle()
        .parent()
        .toggleClass('boost-pfs-filter-sort-active');
    });

    jQ(Selector.filterTreeMobileButton).click(function () {
      jQ('.boost-pfs-filter-top-sorting-mobile .boost-pfs-filter-filter-dropdown').hide();
    });

    jQ(document).on('click', function (e) {
      if (
        jQ(e.target)
          .parents('.boost-pfs-filter-top-sorting')
          .find('.boost-pfs-filter-filter-dropdown').length === 0
      ) {
        jQ('.boost-pfs-filter-filter-dropdown')
          .hide()
          .parent()
          .removeClass('boost-pfs-filter-sort-active');
      }
    });
  };
  // For Toolbar - Build Display type
  ProductDisplayType.prototype.compileTemplate = function () {
    let itemHtml = `<span>${boostPFSThemeConfig.label.toolbar_viewas}</span>`;
    if (boostPFSThemeConfig.custom.product_item_type == 'grid') {
      if (
        boostPFSThemeConfig.custom.view_as_type == 'view_as_type_list_grid_multi_col' &&
        !Utils.isMobile()
      ) {
        itemHtml += `<a href="${Utils.buildToolbarLink(
          'display',
          'grid',
          'list'
        )}" title="${buildDisplayTitle(
          'list'
        )}" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>`;
        itemHtml += `<a href="${Utils.buildToolbarLink(
          'display',
          'list',
          'grid'
        )}" title="${buildDisplayTitle(
          'grid',
          2
        )}" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-2" data-view="grid-2"><span class="icon-fallback-text"></span></a>`;
        itemHtml += `<a href="${Utils.buildToolbarLink(
          'display',
          'list',
          'grid'
        )}" title="${buildDisplayTitle(
          'grid',
          3
        )}" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-3" data-view="grid-3"><span class="icon-fallback-text"></span></a>`;
        itemHtml += `<a href="${Utils.buildToolbarLink(
          'display',
          'list',
          'grid'
        )}" title="${buildDisplayTitle(
          'grid',
          4
        )}" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-4" data-view="grid-4"><span class="icon-fallback-text"></span></a>`;
        itemHtml += `<a href="${Utils.buildToolbarLink(
          'display',
          'list',
          'grid'
        )}" title="${buildDisplayTitle(
          'grid',
          5
        )}" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-5" data-view="grid-5"><span class="icon-fallback-text"></span></a>`;
        itemHtml += `<a href="${Utils.buildToolbarLink(
          'display',
          'list',
          'grid'
        )}" title="${buildDisplayTitle(
          'grid',
          6
        )}" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-6" data-view="grid-6"><span class="icon-fallback-text"></span></a>`;
      } else {
        itemHtml += `<a href="${Utils.buildToolbarLink(
          'display',
          'list',
          'grid'
        )}" title="${buildDisplayTitle(
          'grid'
        )}" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"></span></a>`;
        itemHtml += `<a href="${Utils.buildToolbarLink(
          'display',
          'grid',
          'list'
        )}" title="${buildDisplayTitle(
          'list'
        )}" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>`;
      }
    } else if (
      boostPFSThemeConfig.custom.view_as_type == 'view_as_type_list_grid_multi_col' &&
      !Utils.isMobile()
    ) {
      itemHtml += `<a href="${Utils.buildToolbarLink(
        'display',
        'grid',
        'list'
      )}" title="${buildDisplayTitle(
        'list'
      )}" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>`;
      itemHtml += `<a href="${Utils.buildToolbarLink(
        'display',
        'list',
        'grid'
      )}" title="${buildDisplayTitle(
        'grid',
        2
      )}" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-2" data-view="grid-2"><span class="icon-fallback-text"></span></a>`;
      itemHtml += `<a href="${Utils.buildToolbarLink(
        'display',
        'list',
        'grid'
      )}" title="${buildDisplayTitle(
        'grid',
        3
      )}" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-3" data-view="grid-3"><span class="icon-fallback-text"></span></a>`;
      itemHtml += `<a href="${Utils.buildToolbarLink(
        'display',
        'list',
        'grid'
      )}" title="${buildDisplayTitle(
        'grid',
        4
      )}" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-4" data-view="grid-4"><span class="icon-fallback-text"></span></a>`;
      itemHtml += `<a href="${Utils.buildToolbarLink(
        'display',
        'list',
        'grid'
      )}" title="${buildDisplayTitle(
        'grid',
        5
      )}" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-5" data-view="grid-5"><span class="icon-fallback-text"></span></a>`;
      itemHtml += `<a href="${Utils.buildToolbarLink(
        'display',
        'list',
        'grid'
      )}" title="${buildDisplayTitle(
        'grid',
        6
      )}" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-6" data-view="grid-6"><span class="icon-fallback-text"></span></a>`;
    } else {
      itemHtml += `<a href="${Utils.buildToolbarLink(
        'display',
        'grid',
        'list'
      )}" title="${buildDisplayTitle(
        'list'
      )}" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>`;
      itemHtml += `<a href="${Utils.buildToolbarLink(
        'display',
        'list',
        'grid'
      )}" title="${buildDisplayTitle(
        'grid'
      )}" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"></span></a>`;
    }

    itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);

    return itemHtml;
  };

  function buildDisplayTitle(type, count) {
    if (type === '') return type;
    // Build title for list view
    if (type === 'list') {
      return Labels.listView || 'List view';
    }
    // Build title for grid view
    if (typeof count === 'undefined' || count === 0) return Labels.gridView || 'Grid view';
    return (Labels.gridViewColumns || 'Grid view {{ count }} Columns').replace(
      /{{ count }}/g,
      count
    );
  }

  const originalRenderProductDisplayType = ProductDisplayType.prototype.render;
  ProductDisplayType.prototype.render = function () {
    // Call the original function in our app lib.
    // We don't have to copy a very big function out here to modify.
    // function.call(this, param1, param2) binds the "this" pointer and params to the original function.
    originalRenderProductDisplayType.call(this);

    // Do your custom code after the original function has run
    /** ***** CUSTOM CODE ****** */
    if (hasInit === false) {
      const hiddenInit = document.querySelector('.grid-loading'); // remove this class - used for initial loading
      if (hiddenInit) hiddenInit.classList.remove('grid-loading');
      hasInit = true;
    }
    const quickAddBtns = document.querySelectorAll('.QuickAdd-button');
    const swatches = document.querySelectorAll('[data-id=color-swatch-selector]');
    if (quickAddBtns.length > 0 && swatches.length > 0) {
      window.TASC_BOOST_COLLECTION.init({ quickAdd: quickAddBtns, swatches: swatches });
    }

    /** *************************** */

    // Active current display type
    if (this.$element.length) {
      this.$element.find(this.selector.productDisplayTypeList).removeClass('active');
      this.$element.find(this.selector.productDisplayTypeGrid).removeClass('active');
      if (Utils.stripHtml(Globals.queryParams.display) == 'list') {
        this.$element.find(this.selector.productDisplayTypeList).addClass('active');
      } else if (Utils.stripHtml(Globals.queryParams.display) == 'grid') {
        if (
          boostPFSThemeConfig.custom.view_as_type == 'view_as_type_list_grid_multi_col' &&
          !Utils.isMobile()
        ) {
          const curentGridColumn = boostPFSThemeConfig.custom.products_per_row;
          this.$element.find(this.selector.productDisplayTypeGrid).each(function () {
            const $parent = jQ(this).parent();
            const $cssNames = jQ('.boost-pfs-filter-top-display-type').attr('class').split(' ');
            const $activeClass = $cssNames[$cssNames.length - 1];
            const indexCurrentColumn = $activeClass.split('-')[$activeClass.split('-').length - 1];

            if (
              $parent.hasClass('boost-pfs-filter-view-as-click') &&
              jQ(this).data('view') == $activeClass
            ) {
              jQ(this).addClass('active');

              // jQ('.boost-pfs-filter-product-item').removeClass(function(index, css) {
              // return (css.match (/(^|\s)boost-pfs-filter-grid-width-\S+/g) || []).join(' ');
              // }).addClass('boost-pfs-filter-grid-width-' + indexCurrentColumn);
              if (jQ('.boost-pfs-filter-product-item').length > 0) {
                const arrClass = jQ('.boost-pfs-filter-product-item').attr('class').split(' ');
                let prevClass = '';
                for (let i = 0; i < arrClass.length; i++) {
                  if (arrClass[i].match(/(^|\s)boost-pfs-filter-grid-width-\S+/g)) {
                    prevClass = arrClass[i];
                    break;
                  }
                }
                jQ('.boost-pfs-filter-product-item').removeClass(prevClass);
                jQ('.boost-pfs-filter-product-item').addClass(
                  `boost-pfs-filter-grid-width-${indexCurrentColumn}`
                );

                // jQ('.boost-pfs-filter-product-item').className = jQ('.boost-pfs-filter-product-item').className.replace(/(^|\s)boost-pfs-filter-grid-width-\S+/g , '');
                // jQ('.boost-pfs-filter-product-item').addClass('boost-pfs-filter-grid-width-' + indexCurrentColumn);
              }
            } else if (
              !$parent.hasClass('boost-pfs-filter-view-as-click') &&
              jQ(this).data('view').split('-')[1] == curentGridColumn
            ) {
              jQ(this).addClass('active');
            }
          });
        } else {
          this.$element.find(this.selector.productDisplayTypeGrid).addClass('active');
        }
      }
    }
  };

  // Build Show Limit
  ProductLimit.prototype.compileTemplate = function () {
    let html = '';
    if (boostPFSThemeConfig.custom.show_limit && boostPFSTemplate.hasOwnProperty('showLimitHtml')) {
      const numberList = Settings.getSettingValue('general.showLimitList');
      if (numberList != '') {
        // Build content
        let showLimitItemsHtml = '';
        const arr = numberList.split(',');
        for (const k in sortingArr) {
          showLimitItemsHtml += `<option value="${arr[k].trim()}">${arr[k].trim()}</option>`;
        }
        html = boostPFSTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
      }
    }
    return html;
  };
  // Build Breadcrumb
  Breadcrumb.prototype.compileTemplate = function (colData) {
    if (!colData) colData = this.collectionData;
    let breadcrumbItemsHtml = '';
    if (boostPFSTemplate.hasOwnProperty('breadcrumbHtml')) {
      if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
        const colInfo = colData.collection;
        if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) {
          breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemLink
            .replace(/{{itemLink}}/g, `/collections/${colInfo.handle}`)
            .replace(/{{itemTitle}}/g, colInfo.title);
          breadcrumbItemsHtml += ' {{breadcrumbDivider}} ';
          breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(
            /{{itemTitle}}/g,
            this.collectionTags[0]
          );
        } else {
          breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(
            /{{itemTitle}}/g,
            colInfo.title
          );
        }
      } else {
        breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(
          /{{itemTitle}}/g,
          Settings.getSettingValue('label.defaultCollectionHeader')
        );
      }
    }
    return breadcrumbItemsHtml;
  };

  /** ************************ END BUILD TOOLBAR ************************* */

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function (data) {
    if (!data) data = this.data;

    // Intergrate Review Shopify
    if (
      window.SPR &&
      typeof window.SPR.initDomEls === 'function' &&
      typeof window.SPR.loadBadges === 'function' &&
      boostPFSThemeConfig.custom.show_product_review
    ) {
      window.SPR.initDomEls();
      window.SPR.loadBadges();
    }
    variantCount = 0;

    var productCards = document.querySelectorAll('.boost-pfs-filter-product-item');
    
    var placeToAppend = document.querySelector('[data-where-to-inject]').dataset.whereToInject;
    var placeToAppendNumber = parseInt(placeToAppend)
    var placeToAppendMobile = document.querySelector('[data-where-to-inject-mobile]').dataset.whereToInjectMobile;
    var placeToAppendNumberMobile = parseInt(placeToAppendMobile)

    var placeToAppend2 = document.querySelector('[data-where-to-inject]').dataset.whereToInjectTwo;
    var placeToAppendNumber2 = parseInt(placeToAppend2)
    var placeToAppendMobile2 = document.querySelector('[data-where-to-inject-mobile]').dataset.whereToInjectMobileTwo;
    var placeToAppendNumberMobile2 = parseInt(placeToAppendMobile2)

    var placeToAppend3 = document.querySelector('[data-where-to-inject]').dataset.whereToInjectThree;
    var placeToAppendNumber3 = parseInt(placeToAppend3)
    var placeToAppendMobile3 = document.querySelector('[data-where-to-inject-mobile]').dataset.whereToInjectMobileThree;
    var placeToAppendNumberMobile3 = parseInt(placeToAppendMobile3)

    var placeToAppend4 = document.querySelector('[data-where-to-inject]').dataset.whereToInjectFour;
    var placeToAppendNumber4 = parseInt(placeToAppend4)
    var placeToAppendMobile4 = document.querySelector('[data-where-to-inject-mobile]').dataset.whereToInjectMobileFour;
    var placeToAppendNumberMobile4 = parseInt(placeToAppendMobile4)

    var hero = document.querySelectorAll('[js-appending]');
    var heroMobile = document.querySelectorAll('[js-appending-mobile]')

    var hero2 = document.querySelectorAll('[js-appending-2]');
    var heroMobile2 = document.querySelectorAll('[js-appending-mobile-2]')

    var hero3 = document.querySelectorAll('[js-appending-3]');
    var heroMobile3 = document.querySelectorAll('[js-appending-mobile-3]')

    var hero4 = document.querySelectorAll('[js-appending-4]');
    var heroMobile4 = document.querySelectorAll('[js-appending-mobile-4]')

    if(heroMobile2.length) {
      if(placeToAppendNumberMobile2 == 0) {
        heroMobile2.forEach(function(image){
          productCards[placeToAppendNumberMobile2].before(image)
        })
  
      } else {
        heroMobile2.forEach(function(image){
          productCards[placeToAppendNumberMobile2 -1].after(image)
        })
      }
    }

    if(hero2.length) {
      if(placeToAppendNumber2 == 0) {
        hero2.forEach(function(image){
          productCards[placeToAppendNumber2].before(image)
        })
      } else {
        hero2.forEach(function(image){
          productCards[placeToAppendNumber2 -1].after(image)
        })
      }
    }


    if(heroMobile3.length) {
      if(placeToAppendNumberMobile3 == 0) {
        heroMobile3.forEach(function(image){
          productCards[placeToAppendNumberMobile3].before(image)
        })
  
      } else {
        heroMobile3.forEach(function(image){
          productCards[placeToAppendNumberMobile3 -1].after(image)
        })
      }
    }

    if(hero3.length) {
      if(placeToAppendNumber3 == 0) {
        hero3.forEach(function(image){
          productCards[placeToAppendNumber3].before(image)
        })
      } else {
        hero3.forEach(function(image){
          productCards[placeToAppendNumber3 -1].after(image)
        })
      }
    }

    if(heroMobile4.length) {
      if(placeToAppendNumberMobile4 == 0) {
        heroMobile4.forEach(function(image){
          productCards[placeToAppendNumberMobile4].before(image)
        })
  
      } else {
        heroMobile4.forEach(function(image){
          productCards[placeToAppendNumberMobile4 -1].after(image)
        })
      }
    }

    if(hero4.length) {
      if(placeToAppendNumber4 == 0) {
        hero4.forEach(function(image){
          productCards[placeToAppendNumber4].before(image)
        })
      } else {
        hero4.forEach(function(image){
          productCards[placeToAppendNumber4 -1].after(image)
        })
      }
    }

    if(heroMobile.length) {
      if(placeToAppendNumberMobile == 0) {
        heroMobile.forEach(function(image){
          productCards[placeToAppendNumberMobile].before(image)
        })
  
      } else {
        heroMobile.forEach(function(image){
          productCards[placeToAppendNumberMobile -1].after(image)
        })
      }
    }

    if(hero.length) {
      if(placeToAppendNumber == 0) {
        hero.forEach(function(image){
          productCards[placeToAppendNumber].before(image)
        })
      } else {
        hero.forEach(function(image){
          productCards[placeToAppendNumber -1].after(image)
        })
      }
    }


  };

  // Build additional elements
  Filter.prototype.afterRender = function (data) {
    if (!data) data = this.data;

    handleUpdateSizeFilter();

    // const $lifestyle = jQ('.lifestyle-grid-item');
    // $lifestyle.each(function (i) {
    //   const $el = jQ($lifestyle[i]);

    //   const lifestylePosition = $el.data('position');
    //   const lifestyleEnabled = $el.data('enabled');

    //   // console.log('lifestyle', lifestylePosition, lifestyleEnabled, $el);
    //   if (lifestyleEnabled) {
    //     jQ(
    //       `.boost-pfs-filter-products .boost-pfs-filter-product-item:eq(${lifestylePosition})`
    //     ).before($el.find('.boost-pfs-filter-product-item').clone());
    //   }
    // });

    let totalProduct = `${data.total_product}<span> ${boostPFSThemeConfig.label.items_with_count_other}</span>`;
    if (data.total_product == 1) {
      totalProduct = `${data.total_product}<span> ${boostPFSThemeConfig.label.items_with_count_one}</span>`;
    }

    if (data.total_product == 0) {
      jQ('.boost-pfs-filter-default-toolbar-inner').addClass('boost-pfs-filter-toolbar-product-0');
    } else {
      jQ('.boost-pfs-filter-default-toolbar-inner').removeClass(
        'boost-pfs-filter-toolbar-product-0'
      );
    }

    // remove disabled variants

    data.products.forEach(function (product) {
      const variantsToHide = [];
      const grid_items_to_display = {};
      const color_option = product.options_with_values.filter(function (item) {
        if (item.name == 'color') {
          return item;
        }
      })[0];

      if (color_option) {
        color_option.values.forEach(function (value) {
          grid_items_to_display[value.title] = false;
        });

        product.variants.forEach(function (variant) {
          const metafield = product.metafields.filter(function (meta) {
            if (
              meta.namespace == variant.id ||
              (meta.id == variant.id && meta.key == 'display_variant')
            ) {
              return meta;
            }
          })[0];

          if (metafield) {
            if (metafield.value == 'true') {
              grid_items_to_display[variant.title.split(' / ')[0].trim()] = true;
            }
          }
        });

        // pulled this from previous site in attempt to get splicing to work properly on default collections 8/5
        color_option.values.forEach(function (value) {
          if (!grid_items_to_display[value.title]) {
            const titleEl = jQ(`.boost-pfs-filter-product-item[data-id="${product.id}"]`);
            titleEl.each(function () {
              var variantColorArray = jQ(this).text().split('-');
              var variantColor = variantColorArray[variantColorArray.length - 1].trim();
              if (variantColor === value.title) {
                titleEl.closest('.boost-pfs-filter-product-item').remove();
              }
            });
          }
        });

        // grid_items_to_display have built, now we find which product variants need to be hidden
        product.variants.forEach((variant) => {
          const gridItemDisplay = grid_items_to_display[variant.title.split(' / ')[0].trim()];
          // console.log('gridItemDisplay', gridItemDisplay);
          if (grid_items_to_display && gridItemDisplay === false) {
            variantsToHide.push(variant.id.toString());
          }
        });

        // if (variantsToHide.length > 0) {
        //   console.log('variantsToHide', variantsToHide);
        // }

        color_option.values.forEach(function (value) {
          // now we hide the items if matches criteria
          // console.log(grid_items_to_display);
          if (grid_items_to_display[value.title] === false) {
            const titleEl = jQ(`.boost-pfs-filter-product-item[data-id="${product.id}"]`);
            titleEl.each(function (i) {
              // get variant from href
              const href = this.querySelector('a').href;

              if (href) {
                const variant = href.split('=')[1];
                // TODO: this may be too agressive - ensure we are not removing items that should be kept
                // if no variant then the main product is linked without ?variant=
                if (boostPFSConfig.general.template === 'collection.splice' && !variant) {
                  // console.log('href', href);
                  // console.log('no variant in href, removing', titleEl[i]);
                  titleEl[i].remove();
                }
                if (variantsToHide.includes(variant)) {
                  // console.log('variant is in remove list - removing', titleEl[i]);
                  titleEl[i].remove();
                }
              }
            });
          }
        });
      }
    });

    jQ('.boost-pfs-filter-total-product').html(totalProduct);

    jQ('body').find('.boost-pfs-filter-skeleton-button').remove();

    // Prevent double tap on iOS
    const isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (isiOS) {
      Utils.isMobile() &&
        jQ('.boost-pfs-filter-product-item')
          .find('a')
          .on('touchstart', function () {
            isScrolling = !1;
          })
          .on('touchmove', function () {
            isScrolling = !0;
          })
          .on('touchend', function () {
            isScrolling || (window.location = jQ(this).attr('href'));
          });
    }

    // Add swatch attribute data-handle
    jQ('.boost-pfs-filter-option-swatch-image').each(function (index, element) {
      jQ(element).attr('data-handle', handleize(jQ(element).attr('title')));
    });

    // Build Image Swap. Put this function here to impprove the pagespeed.
    // this func is required for the image swap on hover
    swapImage(data);

    // Build Equal Height
    if (Utils.stripHtml(Globals.queryParams.display) !== 'list') {
      setTimeout(function () {
        equalHeight(data);
      }, 700);
    }

    jQ(window).resize(function () {
      if (Utils.stripHtml(Globals.queryParams.display) !== 'list') {
        setTimeout(function () {
          equalHeight(data);
        }, 700);
      }
    });

    // Build Event Color Swatch
    if (boostPFSThemeConfig.custom.swatch_change_img != 'none') {
      eventColorSwatches(boostPFSThemeConfig.custom.swatch_change_img);
    }

    if (boostPFSThemeConfig.custom.swatch_color_event_change_image != 'none') {
      eventColorSwatches(boostPFSThemeConfig.custom.swatch_color_event_change_image);
    }

    if (typeof boostRemoveImageLoadingAnimation === 'function') {
      boostRemoveImageLoadingAnimation(
        jQ(Selector.products).find('[data-boost-image-loading-animation]')
      );
    }

    // Layout Fullwidth Page
    if (
      boostPFSThemeConfig.custom.hasOwnProperty('layout_type') &&
      boostPFSThemeConfig.custom.layout_type == 'fullwidth' &&
      !Utils.isMobile()
    ) {
      jQ('body').addClass('boost-pfs-filter-fullwidth-page');
    }
    document.addEventListener('scroll', function () {
      if (
        jQ('.boost-pfs-filter-tree-h.boost-pfs-filter-stick').length > 0 &&
        jQ(window).width() > 767
      ) {
        jQ('.boost-pfs-filter-custom-sorting .boost-pfs-filter-filter-dropdown')
          .hide()
          .parent()
          .removeClass('boost-pfs-filter-sort-active');
      }
    });

    // Fix confict Sticky Mobile theme Streamline
    if (jQ('.site-nav__thumb-menu').length > 0 && Utils.isMobile()) {
      const heightHeaderThemeStick = jQ('.site-nav__thumb-menu').height() + 40;
      jQ('.boost-pfs-filter-tree-mobile-button-stick-wrapper')
        .css('bottom', heightHeaderThemeStick)
        .addClass('boost-pfs-filter-sticky-bottom');
      jQ('.boost-pfs-filter-mobile-style1').addClass(
        'boost-pfs-filter-mobile-style1-sticky-bottom'
      );
    }
  };

  function removeClassByPrefix(node, prefix) {
    const regx = new RegExp(`\\b${prefix}[^ ]*[ ]?\\b`, 'g');
    node.className = node.className.replace(regx, '');
    return node;
  }

  const original_onClickEventProductDisplayType = ProductDisplayType.prototype._onClickEvent;
  ProductDisplayType.prototype._onClickEvent = function (event) {
    // Call the original function in our app lib.
    // We don't have to copy a very big function out here to modify.
    // function.call(this, param1, param2) binds the "this" pointer and params to the original function.
    original_onClickEventProductDisplayType.call(this, event);

    // Do your custom code after the original function has run
    /*  View As Type 2/3/4/5/6 */

    if (
      boostPFSThemeConfig.custom.view_as_type == 'view_as_type_list_grid_multi_col' &&
      !Utils.isMobile()
    ) {
      jQ('.boost-pfs-filter-top-display-type').addClass('boost-pfs-filter-view-as-click');
      const currentClass = jQ(event.target).data('view');
      jQ('.boost-pfs-filter-top-display-type')[0].className = jQ(
        '.boost-pfs-filter-top-display-type'
      )[0].className.replace(/(^|\s)grid-\S+/g, '');
      jQ('.boost-pfs-filter-top-display-type').addClass(currentClass);
    }
  };

  ProductListPlaceholder.prototype.render = function () {
    // Set limit number for product skeleton
    const placeholderLimit = this.settings.productsPerRow || this.settings.placeholderProductPerRow;
    // Build placeholder items
    const placeholderItem = this.compileTemplate();
    this.$element = [];
    for (let i = 0; i < placeholderLimit; i++) {
      this.$element.push(jQ(placeholderItem));
    }
    // Show placeholder before send filter request OR hide it after get filter data
    if (!this.isFetchedProductData) {
      this.setShow();
    } else {
      this.setHide();
    }
  };

  ProductListPlaceholder.prototype.compileTemplateExtra = function () {
    // Todo: Build placeholder for List mode
    const template = boostPFSTemplate.productListPlaceholderHtml;
    const imgRatioSetting = parseFloat(this.settings.placeholderImageRatio);
    const imgRatio = imgRatioSetting > 0 ? imgRatioSetting : 1.4; // It mean w1:h1.4
    /**
     * Set product class for product skeleton (to set column, style, etc.)
     * - If had defined product_grid_class in boostPFSThemeConfig => use this config ELSE use our setting
     */
    return template
      .replace(/{{class.filterProductSkeleton}}/g, Class.filterProductSkeleton)
      .replace(/{{class.filterSkeleton}}/g, Class.filterSkeleton)
      .replace(/{{class.filterSkeletonText}}/g, Class.filterSkeletonText)
      .replace(/{{paddingTop}}/g, imgRatio * 100);
  };

  /* Prevent conflict with theme vendor js */
  // Commented this out, this was what was causing the errors in collection page
  // Array.prototype.insert = function (a, b) {};

  /* Math qual Height */
  function equalHeight(data) {
    let equal_i = -1;
    const equal_els = [];
    let equal_element = null;

    // Equal Height Title
    jQ('.boost-pfs-filter-product-item').each(function (i, element) {
      const offsetTop = jQ(element).offset().top;
      if (!equal_element || equal_element.offset().top !== offsetTop) {
        equal_element = jQ(element);
        equal_i++;
      }

      if (!equal_els[equal_i]) {
        equal_els[equal_i] = [];
      }
      equal_els[equal_i].push(element);
    });

    for (let i = 0; i < equal_els.length; i++) {
      let max = 0;
      const maxRatio = 0;
      const iLength = equal_els[i].length;

      for (let j = 0; j < equal_els[i].length; j++) {
        const item = equal_els[i][j];
        const height = jQ(item).find('.boost-pfs-filter-product-bottom-inner').height();
        max = Math.max(max, height);
      }
      jQ(equal_els[i]).find('.boost-pfs-filter-product-bottom-inner').css({ 'min-height': max });
    }

    const { aspect_ratio } = boostPFSFilterConfig.general;

    if (aspect_ratio != 'false') {
      var cropImagePosition = boostPFSFilterConfig.general.cropImagePossitionEqualHeight;

      var widthImage = jQ('.boost-pfs-filter-product-item').width();
      var indexData = 0;

      // For Ratio
      if (aspect_ratio != 'false' && aspect_ratio != 'auto') {
        var heightImage = 0;
        var widthImage = jQ('.boost-pfs-filter-product-item').width();
        if (aspect_ratio != 'false' && aspect_ratio != 'auto' && aspect_ratio != 'other') {
          var ratioWidthHeight = boostPFSThemeConfig.custom.aspect_ratio;
        } else {
          var ratioWidthHeight = '';
        }

        var ratioWidthHeightOther = boostPFSThemeConfig.custom.aspect_ratio_other;
        if (ratioWidthHeightOther == '' && ratioWidthHeight == '') {
          return null;
        }
        if (aspect_ratio != 'other') {
          ratioWidthHeight = ratioWidthHeight.split(':');
          ratioWidthHeight = parseInt(ratioWidthHeight[1]) / parseInt(ratioWidthHeight[0]);
          heightImage = widthImage * ratioWidthHeight;
        } else if (ratioWidthHeightOther != '' && aspect_ratio == 'other') {
          ratioWidthHeightOther = ratioWidthHeightOther.split(':');
          ratioWidthHeightOther =
            parseInt(ratioWidthHeightOther[1]) / parseInt(ratioWidthHeightOther[0]);
          heightImage = widthImage * ratioWidthHeightOther;
        }

        jQ('.boost-pfs-filter-product-item-image-link')
          .css({ 'padding-top': `${heightImage}px` })
          .addClass(`boost-pfs-filter-crop-image-position-${cropImagePosition}`);
      }
    }

    const { equal_height } = boostPFSFilterConfig.general;

    if (equal_height != 'false') {
      var cropImagePosition = boostPFSFilterConfig.general.cropImagePossitionEqualHeight;

      var widthImage = jQ('.boost-pfs-filter-product-item').width();
      var indexData = 0;

      // For Ratio
      if (equal_height != 'false' && equal_height != 'auto') {
        var heightImage = 0;
        var widthImage = jQ('.boost-pfs-filter-product-item').width();
        if (equal_height != 'false' && equal_height != 'auto') {
          var ratioWidthHeight = boostPFSThemeConfig.custom.equal_height;
        } else {
          var ratioWidthHeight = '';
        }

        var ratioWidthHeightOther = boostPFSThemeConfig.custom.ratio_width_height_other;
        if (ratioWidthHeightOther == '' && ratioWidthHeight == '') {
          return null;
        }
        if (ratioWidthHeightOther == '') {
          ratioWidthHeight = ratioWidthHeight.split(':');
          ratioWidthHeight = parseInt(ratioWidthHeight[1]) / parseInt(ratioWidthHeight[0]);
          heightImage = widthImage * ratioWidthHeight;
        } else if (ratioWidthHeightOther != '') {
          ratioWidthHeightOther = ratioWidthHeightOther.split(':');
          ratioWidthHeightOther =
            parseInt(ratioWidthHeightOther[1]) / parseInt(ratioWidthHeightOther[0]);
          heightImage = widthImage * ratioWidthHeightOther;
        }

        jQ('.boost-pfs-filter-product-item-image-link')
          .css({ 'padding-top': `${heightImage}px` })
          .addClass(`boost-pfs-filter-crop-image-position-${cropImagePosition}`);
      }
    }
  }

  // Swap Image
  function swapImage(data) {
    if (!Utils.isMobile()) {
      if (
        boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
        boostPFSThemeConfig.custom.active_image_swap == true
      ) {
        let dataSrcSetFlipImg = '';
        let dataSrcFlipImg = '';
        let flipImageAlt = '';
        const dataSizes = 'auto';
        let dataWidths = '';
        let html = '';

        jQ('.boost-pfs-filter-product-item').each(function () {
          const productItemSelector = jQ(this);
          const imgSelector = productItemSelector.find('.boost-pfs-filter-product-item-main-image');
          
          if (
            typeof imgSelector.data('img-flip-src') !== 'undefined' &&
            imgSelector.data('img-flip-src') !== ''
          ) {
            dataSrcFlipImg = imgSelector.data('img-flip-src');
            dataSrcSetFlipImg = imgSelector.data('img-flip-srcset');
            flipImageAlt = imgSelector.attr('alt');
            dataWidths = imgSelector.data('widths');
            html =
              `<img class="boost-pfs-filter-product-item-flip-image lazyload Image--lazyLoad"` +
              `data-srcset="${dataSrcSetFlipImg}" ` +
              `data-src="${dataSrcFlipImg}" ` +
              `data-widths="[${dataWidths}]" ` +
              `data-sizes="${dataSizes}" ` +
              `src="${boostPFSImgDefaultSrc}" ` +
              `alt="${flipImageAlt}" />`;

            productItemSelector.find('.boost-pfs-filter-product-item-image-link').append(html);
          }
        });
      }
    }
  }

  // Build Placeholder for the first load
  function boostRemoveImageLoadingAnimation($selector) {
    if ($selector.length) {
      $selector.removeAttr('data-boost-image-loading-animation');
    }
  }
  /* Expand Filter */
  // jQ(document).ready(function () {
  //   jQ('.boost-pfs-filter-custom-filter-button').on('click', function () {
  //     jQ('body').toggleClass('boost-pfs-filter-custom-drawer-open');
  //   });
  //   jQ('.boost-pfs-filter-custom-drawer-close').click(function () {
  //     jQ('body').removeClass('boost-pfs-filter-custom-drawer-open');
  //   });
  //   jQ('.boost-pfs-filter-custom-drawer-overlay').click(function () {
  //     jQ('body').removeClass('boost-pfs-filter-custom-drawer-open');
  //   });

  //   // Bind changing options with enter/space key for ADA
  //   jQ('.boost-pfs-filter-custom-drawer-close, .boost-pfs-filter-custom-drawer-overlay').on(
  //     'keydown',
  //     (event) => {
  //       if (event.target && (event.keyCode == 13 || event.keyCode == 32)) {
  //         jQ(event.target).click();
  //       }
  //     }
  //   );

  //   // Fix issue header fix on the Parallax theme
  //   if (jQ('.mm-fixed-top').length > 0) {
  //     const headerFixedHeight = jQ('.mm-fixed-top').height();
  //     jQ('.boost-pfs-filter-collection-header-wrapper').css('margin-top', headerFixedHeight);
  //   }
  // });
})();

function handleUpdateSizeFilter() {
  const sizeFilterSectionDesktop = document.querySelector('#boost-pfs-filter-tree2-pf-opt-size');
  const sizeFilterSectionMobile = document.querySelector('#boost-pfs-filter-tree-pf-opt-size');
  const sections = [sizeFilterSectionDesktop, sizeFilterSectionMobile].filter(Boolean);

  if (sections.length > 0) {
    sections.forEach((section) => {
      const sizeButtons = section.querySelectorAll('.boost-pfs-filter-button');
      if (sizeButtons) {
        sizeButtons.forEach((sizeBtn) => {
          const valueEl = sizeBtn.querySelector('.boost-pfs-filter-option-value');
          if (valueEl) {
            const value = valueEl.textContent;
            if (value) {
              const strLength = value.length;
              if (strLength > 4) {
                sizeBtn.style.fontSize = '0.8rem';
              }
            }
          }
        });
      }
    });
  }
}
